const VacationErrorCodes = {
  VAC00001: 'The contract is on leave',
  VAC00002: 'The contract is terminated',
} as const;

export default VacationErrorCodes;
